/**
 * Freemium service for SmartInventory
 * Handles freemium checks, ad tracking, and usage limits
 */

import axios from 'axios';

// Use axios global baseURL (configured in App.js from REACT_APP_BACKEND_URL).
// Never hardcode localhost here — it would break Android release builds.

export const freemiumService = {
  async getFreemiumStatus() {
    try {
      const response = await axios.get('/freemium/status');
      return response.data.status;
    } catch (error) {
      console.error('[Freemium] Error getting status:', error.message);
      return null;
    }
  },

  async checkReceiptScanAllowed() {
    try {
      const response = await axios.post('/freemium/check-receipt-scan');
      return response.data.check;
    } catch (error) {
      if (error.response?.status === 402 || error.response?.status === 403) {
        return {
          allowed: false,
          ad_required: error.response.data?.detail?.includes('publicité'),
          reason: 'limit_or_ad',
          message: error.response.data?.detail || 'Limitation atteinte'
        };
      }
      console.error('[Freemium] Error checking receipt scan:', error.message);
      return { allowed: true };
    }
  },

  async checkBarcodeScanAllowed() {
    try {
      const response = await axios.post('/freemium/check-barcode-scan');
      return response.data.check;
    } catch (error) {
      if (error.response?.status === 402 || error.response?.status === 403) {
        return {
          allowed: false,
          ad_required: true,
          reason: 'ad_required',
          message: error.response.data?.detail || 'Ad required'
        };
      }
      return { allowed: true };
    }
  },

  async checkBudgetAccess() {
    try {
      await axios.post('/freemium/check-budget-access');
      return { allowed: true };
    } catch (error) {
      if (error.response?.status === 403) {
        return {
          allowed: false,
          reason: 'free_tier',
          message: error.response.data?.detail || 'Feature not available in free tier'
        };
      }
      return { allowed: true };
    }
  },

  async recordUsage(feature) {
    try {
      const response = await axios.post('/freemium/record-usage', { feature });
      return response.data;
    } catch (error) {
      console.warn('[Freemium] Error recording usage:', error.message);
      return { success: false };
    }
  },

  async watchAd(adType) {
    try {
      const response = await axios.post('/freemium/watch-ad', { ad_type: adType });
      return response.data;
    } catch (error) {
      console.error('[Freemium] Error registering ad watch:', error.message);
      return { success: false };
    }
  },

  async getSubscriptionPlans() {
    try {
      const response = await axios.get('/freemium/subscription-plans');
      return response.data.plans;
    } catch (error) {
      console.error('[Freemium] Error getting plans:', error.message);
      return [];
    }
  }
};

export default freemiumService;
